import React from "react";
import ActiveBadge from "../../../components/ActiveBadge";
import Chip from "../../../components/Chip";
import { TRIGGER_TYPE_LABEL } from "../../../features/builder.constants";
import { EMAIL_ONLY_TYPES } from "../features/recipient-type.constants";

function TriggerChips({ triggers }) {
  if (!triggers?.length) return <Chip tone="brand">All triggers</Chip>;
  return (
    <div className="flex flex-wrap gap-1">
      {triggers.map((trigger) => (
        <Chip key={trigger}>{TRIGGER_TYPE_LABEL[trigger] ?? trigger}</Chip>
      ))}
    </div>
  );
}

// Columns of the Recipient Type list. `start` is the row number offset of the current page.
export const getRecipientTypeColumns = (start) => [
  {
    key: "id",
    label: "S.No",
    width: "70px",
    sortable: false,
    render: (row) => <span className="text-xs text-text_muted">{start + row.__index + 1}</span>,
  },
  {
    key: "name",
    label: "Recipient Type",
    sortable: true,
    render: (row) => (
      <div className="flex min-w-0 max-w-[320px] flex-col">
        <span className="truncate font-medium text-text_primary">{row.name || "—"}</span>
        <span className="truncate font-mono text-[11px] text-text_muted">{row.type_key}</span>
      </div>
    ),
  },
  {
    key: "needs_subject",
    label: "Needs",
    sortable: true,
    render: (row) => (
      <div className="flex flex-wrap gap-1">
        {row.needs_subject ? <Chip tone="warning">Subject user</Chip> : <span className="text-xs text-text_muted">—</span>}
        {EMAIL_ONLY_TYPES.includes(row.type_key) && <Chip tone="info">Email only</Chip>}
      </div>
    ),
  },
  {
    key: "allowed_triggers",
    label: "Triggers",
    sortable: false,
    render: (row) => <TriggerChips triggers={row.allowed_triggers} />,
  },
  {
    key: "sort_order",
    label: "Order",
    sortable: true,
    render: (row) => <span className="text-xs text-text_secondary">{row.sort_order ?? 0}</span>,
  },
  {
    key: "is_activated",
    label: "Status",
    sortable: true,
    render: (row) => <ActiveBadge active={row.is_activated} />,
  },
];
